
export const BUILDER_TYPE = {
    PROJECT: 'project',
    TEMPLATE: 'template',
    COMPONENT: 'component',
}